/* eslint-disable react/no-danger */
import React, { memo, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const Select = memo(
  ({
    value,
    list = [],
    name,
    category,
    onChange,
    align = 'vertical',
    label,
    image,
  }) => {
    const isVerticalAlign = align === 'vertical';
    const classWrapper = useMemo(
      () =>
        classNames('grid mx-0', {
          'grid-cols-1 gap-4': isVerticalAlign,
          [`${
            list.length > 3
              ? 'grid-cols-3 max-md-grid-cols-2'
              : `grid-cols-${list.length}`
          } text-center gap-4`]: !isVerticalAlign,
        }),
      [isVerticalAlign, list.length],
    );
    const classSelect = useCallback(
      (item, index) =>
        classNames(
          'flex-col space-y-3 col-span-1 border py-3 px-5 rounded text-sm items-center flex cursor-pointer transition duration-300 text-slate-400 hover:bg-cyan-100 hover:text-cyan-700 hover:border-cyan-500',
          {
            'lg:mx-56': !item.image && !image,
            'bg-cyan-50 border-cyan-500 shadow text-cyan-700':
              value === item.value && item.label === label,
            'text-center justify-center': !isVerticalAlign,
          },
          `animate-fade-in delay-${index}`,
        ),
      [image, isVerticalAlign, label, value],
    );

    const handleChange = useCallback(
      item => () => {
        const { value: val, label, pro, con } = item;
        onChange({ target: { name, value: val, category, label, pro, con } });
      },
      [category, name, onChange],
    );

    return (
      <div className={classWrapper}>
        {list.map((x, index) => (
          <div
            id={x.label}
            key={x.label}
            className={classSelect(x, index)}
            data-selected={value === x.value}
            onClick={handleChange(x)}>
            {x.image && (
              <div
                className="bg-origin-padding w-full h-24 md:h-36 bg-contain bg-no-repeat bg-center"
                style={{ backgroundImage: `url(${x.image})` }}
              />
            )}
            <label dangerouslySetInnerHTML={{ __html: x.label }} />
          </div>
        ))}
      </div>
    );
  },
);

Select.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  list: PropTypes.array,
  onChange: PropTypes.func,
  align: PropTypes.oneOf(['vertical', 'horizontal']),
  category: PropTypes.string,
  image: PropTypes.string,
};
